import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { triggerOrderManifest } from '../../store/shippingSlice';
import './AdminShippingPanel.css';

const AdminShippingPanel = ({ pendingOrders = [{ id: 1, grand_total: 49999.00, payment_method: 'RAZORPAY', created_at: '2026-07-04' }] }) => {
    const dispatch = useDispatch();
    const { operationsLoading, dispatchLogs, error } = useSelector(state => state.shipping);

    const handleGenerateManifestAction = (orderId) => {
        if(window.confirm(`Initiate automated fulfillment manifest protocol for Order ID #${orderId}?`)) {
            dispatch(triggerOrderManifest(orderId));
        }
    };

    return (
        <div className="admin-shipping-container">
            <header className="admin-shipping-header-block">
                <h2>Logistics Fulfillment Center (Shiprocket Automated Engine)</h2>
                <p>Monitor pending orders, execute API handshakes, print labels, and assign automated multi-carrier AWB tracking tokens.</p>
            </header>

            {error && <div className="shipping-error-banner-alert">{error}</div>}
            {dispatchLogs && <div className="shipping-success-banner-alert">Fulfillment Manifesting Stage Confirmed: {JSON.stringify(dispatchLogs.message)}</div>}

            <div className="shipping-table-wrapper">
                <table className="shipping-native-table">
                    <thead>
                        <tr>
                            <th>Internal Order Ref</th>
                            <th>Date Lodged</th>
                            <th>Payment Modality</th>
                            <th>Grand Total Payable</th>
                            <th>Fulfillment Automation Interface</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pendingOrders.map((order) => (
                            <tr key={order.id}>
                                <td><strong>#ORD-{order.id}</strong></td>
                                <td>{order.created_at}</td>
                                <td><span className="badge-payment-type">{order.payment_method}</span></td>
                                <td>₹{parseFloat(order.grand_total).toLocaleString('en-IN')}</td>
                                <td>
                                    <button 
                                        onClick={() => handleGenerateManifestAction(order.id)} 
                                        className="btn-shipping-generate-api"
                                        disabled={operationsLoading}
                                    >
                                        {operationsLoading ? "Transmitting Streams..." : "Transmit Manifest to Shiprocket"}
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminShippingPanel;